// Mirrors PrivateRideWizard pricing so phone bookings get the same fares
const PRICING = {
  base_fare: 5.0,
  per_mile: 2.25,
  minimum_fare: 15.0,
  additional_stop: 5.0,
  wait_30_min: 20.0,
  wait_60_min: 40.0,
  wait_per_30_min: 20.0,
};

export const estimatePrivateFare = (f) => {
  const miles = f.estimated_miles || 5;
  let total = PRICING.base_fare + miles * PRICING.per_mile * (f.service_type === "round_trip" ? 2 : 1);
  total += (f.stops || []).filter((s) => s.address).length * PRICING.additional_stop;
  if (f.wait_and_return && f.wait_time > 0) {
    if (f.wait_time <= 30) total += PRICING.wait_30_min;
    else if (f.wait_time <= 60) total += PRICING.wait_60_min;
    else total += PRICING.wait_60_min + Math.ceil((f.wait_time - 60) / 30) * PRICING.wait_per_30_min;
  }
  return Math.max(total, PRICING.minimum_fare);
};
